/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Table\TablePaper.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday February 13th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday February 13th 2024 10:09:22 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";

type TablePaperProps = {
    headerList: string[],
    items: JSX.Element[],
    showUser?: boolean
};

export function TablePaper(props: TablePaperProps) {
    const buildTableHeader = () => {
        const tableHeader = props.headerList;
        return tableHeader.map(val =>
            <TableCell sx={{fontWeight: "bold"}} align="center" key={Math.random()}>{translator.decode(`table.headers.${val}`)}</TableCell>
        );
    };

    return (
        <Paper elevation={4} sx={{overflowX: "auto"}} >
            <Table stickyHeader >
                <TableHead>
                    <TableRow>
                        { buildTableHeader() }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.items}
                </TableBody>
            </Table>
        </Paper>
    )
};
